var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.theVisible)?_c('div',{staticClass:"kst-error"},[_c('div',{staticClass:"has-text-danger ks-flex-center mt-4"},[_c('kst-icon',{staticClass:"ks-display-inline mr-2",attrs:{"error-mode":""}}),_vm._v(" "+_vm._s(_vm.theLabel)+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }